import { gql } from '@apollo/client'

import { BRAND_CURATION_TASK_LIST_FRAGMENT } from '../fragments'

const BRAND_CURATION_TASK_QUERY = gql`
  query brandCurationTasks(
    $filters: BrandCurationTaskFiltersInput!
    $pagination: PaginationInput!
  ) {
    brandCurationTasks(filters: $filters, pagination: $pagination) {
      total
      result {
        ...BrandCurationTaskListFragment
      }
    }
  }
  ${BRAND_CURATION_TASK_LIST_FRAGMENT}
`

export default BRAND_CURATION_TASK_QUERY
